module.exports = __webpack_public_path__ + "fonts/DINNextLTW23-Regular.4b1a7d56.woff";